<template>
  <div id="app">
    <transition name="show-from-left">
        <popover name="helpsensor" :width="240">
            <Help :titleChart="titleChart">
            <div slot="content">
              <p> {{ $t("261") }}</p>
            </div>
          </Help>
        </popover>
    </transition>

    <div class="title-charts title-bt-help title-margin">{{ $t("262") }}
      <button class="bt-help" v-popover:helpsensor.right><i class="icon-help ti-help-alt"></i></button>
    </div>

    <highcharts :options="chartOptions" ref='chart' class='my-chart'></highcharts>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Vue from 'vue'
import axios from 'axios';
import mixin from '../../../../utils/mixin';

import Popover  from 'vue-js-popover'
Vue.use(Popover)
import Help from 'src/components/Dashboard/Views/components/Help'

export default {
  name: 'charts',
  components: {
    Help
  },
  data () {
    return {
      titleChart: this.$t("262"),
      tableData: [],
      chartOptions: {
        //colors: ['#8b3d88', '#90ed7d', '#e4d354', '#f45b5b', '#6b91c9', '#3e9b80', '#3257a8'],
        chart: {
          type: 'heatmap',
          backgroundColor: 'rgba(0,0,0,0)',
          marginTop: 40,
          // marginBottom: 80,
          plotBorderWidth: 1,
          height:520
        },


        title: {
            text: ''
        },

        xAxis: {
            // categories: ['<= 3', '> 3', '> 7', '> 15', '> 30', '> 60']
            categories: [],
            title:{
              text: this.$t("305"),
              style: {
                color: '#fff'
              }
            }
        },

        yAxis: {
            // categories: ['JC', 'MEIO AMBIENTE', 'PACKAGING', 'PROCESSO', 'PROCESSO CERVEJA', 'UTILIDADES'],
            categories: [],
            title: null,
            reversed: true,
        },

        tooltip: {
          formatter: function () {
            let value = this.point.value

            if (value || value == 0){
              // return '<b>' + this.point.series.yAxis.categories[this.point.options.y] + '</b><br><b>' + value + ' % ' +'</b><b>' + this.point.series.xAxis.categories[this.point.options.x] + ' days</b>';
              if (this.point.x == 5){
                return '<b>' + this.point.series.yAxis.categories[this.point.options.y] + '</b><br><b>' + value + ' sensors</b>';
              }
              return '<b>' + this.point.series.yAxis.categories[this.point.options.y] + '</b><br><b>' + value + ' %</b>';
            }
            return '<b>' + this.point.series.yAxis.categories[this.point.options.y] + '</b><br><b>No data!</b>'
          },
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          style: {
            color: '#F0F0F0'
          }
        },

        series: [{
          borderWidth: 1,
          data: [],
          showInLegend: false,
          dataLabels: {
            enabled: true,
            color: '#000000'
          }
        }],
        plotOptions: {
          series: {
            dataLabels:{
              formatter:function() {
                // Não adiciona % para a coluna Delivered
                if (this.point.x == 5){
                  return '<span style="color: #fff; font-size:14px"> #' + this.point.value + '</span>';
                }
                return '<span style="font-size:14px;" >' +  this.point.value + '</span>';
              }
            },
            events:{
              click: this.loadGrid
            },
            cursor: 'pointer',
          },
          heatmap: {
            borderColor: '#000'
          }
        },

        loading: {
            labelStyle: {
                color: 'black',
                textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff',
            },
            style: {
                backgroundColor: 'none',
                opacity: 1,
            }
        },

        exporting: { enabled: false },
        credits: {
          enabled: false
        },
      },//fim chartOptions
    }
  },
  mixins: [mixin],
  methods: {
    ...mapMutations(['changeGridOnline']),
    loadGrid(event){

      let area_title = this.chartOptions.yAxis.categories[event.point.y].split(' ').filter(item => { return item != '-'}).join('_');
      let area = event.point.y != 0 ? this.chartOptions.yAxis.categories[event.point.y] : '';
      let status = event.point.x != 5 ? event.point.x : '';

      let point_name = area_title
      let NAME_CHART = this.$t("370") + ' - ' + point_name.toUpperCase()

      const ENDPOINT = `v1/mysemeq-ambev/get-sensors-out-service-grid?corp=${this.filtersOn.corp}&region=${this.filtersOn.region}&planta=${this.filtersOn.planta}&area=${area}&status=${status}&area_f=${this.filtersOn.area_f}&sector_f=${this.filtersOn.sector_f}&machine=${this.filtersOn.machine}&subset=${this.filtersOn.subset}`

      let gridOnline = {
        title: this.$t("370") + ' - ' + this.chartOptions.yAxis.categories[event.point.y],
        url: ENDPOINT,
        name_chart: NAME_CHART,
        columns: {
          "area": [this.$t("311"), 'area_f'],
          "setor": [this.$t("312")],
          "conj": [this.$t("316"), 'conjunto'],
          "conj_tag": [this.$t("317")],
          "equip": [this.$t("313")],
          "equip_tag": [this.$t("314")],
          "serie": [this.$t("339")],
          "versao": [this.$t("336")],
          "data": [this.$t("334")],
          "bateria": [this.$t("335")],
          "sinal_nivel": [this.$t("337")],
          "node": [this.$t("338"), 'nodo'],
          "status": ['Status'],
          "id_planta": ['id_planta']
        },
        show: true,
        titleHelp: 'Grid - ' + this.$t("370"),
        txtHelp: this.$t("371") 
      }

      if (!this.filtersOn.planta) {
        gridOnline.columns = {"rows": [''], 'planta': [this.$t("310"), 'planta_f'], ...gridOnline.columns}
      }
      else{
        gridOnline.columns = {"rows": [''],  ...gridOnline.columns}
      }

      if (event.point.value) { this.changeGridOnline(gridOnline) }

    },
    getData(){

      const API = process.env.ROOT_API;

      let param = {
        'corp': this.filtersOn.corp,
        'region': this.filtersOn.region,
        'planta': this.filtersOn.planta,
        'area_f': this.filtersOn.area_f,
        'sector_f': this.filtersOn.sector_f,
        'machine': this.filtersOn.machine,
        'subset': this.filtersOn.subset,
      }

      this.$refs.chart.chart.showLoading();

      let self = this;
      axios({method: 'GET', url: API + 'v1/mysemeq-ambev/get-sensors-out-service', params: param, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
          .then(function({ data }){
              if (data){

                // let colors = ['#2fb62f', '#f8ff00', '#ffc300', '#f56b00', '#fe0000', 'transparent']
                let colors = ['#90ed7d', '#e4d354', '#ffc300', '#f0893a', '#f45b5b', 'transparent']

                if (data[0].length == 0){
                  self.$refs.chart.chart.showLoading('No data');
                  return false;
                }

                let points = data[0].map( elem => {
                  elem['color'] = colors[elem.x]
                  return elem
                })

                self.chartOptions.series[0].data = points;
                self.chartOptions.xAxis.categories = data[1];

                data[2][0] = (self.filtersOn.planta_name == 'All' ? '' : self.filtersOn.planta_name) || self.filtersOn.region || 'ABInBev'; // Nome da planta/região na primeira posicao do Y

                self.chartOptions.yAxis.categories = data[2];

                //heigth inicial: 520
                if(data[2].length > 11){
                  self.chartOptions.chart.height = 1300
                }else{
                   self.chartOptions.chart.height = 520
                }



              }
          })
          .catch(function(error){
            self.$refs.chart.chart.showLoading('Error');

            // from mixin
            self.ApiErrorHandler(self, error.response.data.status_code);
          })

   }
  },
  computed: {
    ...mapGetters(['filtersOn']),
  },
  watch: {
    filtersOn: function(newValue){
     this.getData();
    },
  }
}
</script>
<style >
.highcharts-title tspan {
    fill: #fff;
    stroke: none!important;
    stroke-width: 1px;
    stroke-linejoin: round;
    color: #fff;
    font-weight: normal;
    font-size: 14px;
}
.highcharts-axis-labels tspan {
    fill: #fff;
    stroke: none!important;
    stroke-width: 1px;
    stroke-linejoin: round;
    color: #fff;
    font-weight: normal;
    font-size: 10px;
}
.highcharts-axis-labels text tspan {
  color: #fff!important;
  fill: #fff!important;
}
.highcharts-axis-labels text{
  color: #fff!important;
  fill: #fff!important;
}
.highcharts-text-outline {
  fill: none!important;
  stroke: none!important;
  color: #000;
}

div[data-popover="helpsensor"] {
  left: 66% !important;
  top: 0% !important;
}

.title-margin{
  margin-bottom: -20px;
  position: absolute;
  top: 0px;
  right: 33%;
  z-index: 99999;
}

/*Adicionado para ajuste no numeros, pois estavam passando da linha da tabela (26-01-2021) lindsay
.highcharts-label text tspan{
  font-size: 11.5px!important;
} */
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/ChartsOnline/HeatMapSensor.vue